import '../scss/style.scss';
import '../js/advice.js';

console.log('Parcel is working. Hurray!');